module.exports = __webpack_public_path__ + "2de1c8f78984b8c5410bc91de5ccce58.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/hero-secondary.png
// module id = 1230
// module chunks = 0